module.exports = __webpack_public_path__ + "img/main-logo.798d5d02.png";